import { PublicLayout } from "@/components/layout/PublicLayout";
import { ShieldCheck, MapPin, Truck } from "lucide-react";

export default function About() {
  return (
    <PublicLayout>
      <section className="max-w-4xl mx-auto px-6 py-24">
        <span className="text-xs uppercase tracking-[0.25em] font-bold text-xd-orange">About XD</span>
        <h1 className="mt-4 font-heading text-5xl font-black tracking-tighter">Everything hotshot. One platform.</h1>
        <p className="mt-6 text-lg text-xd-muted leading-relaxed">
          XD FREIGHT is building the operating system for the hotshot trucking industry — a place where owner-operators
          find loads, get paid, run their business, and grow their fleet, and where shippers move freight with a carrier
          they can trust.
        </p>

        <div className="mt-12 grid gap-6 sm:grid-cols-3">
          <Card icon={Truck} title="Property Carrier" value="USDOT 3994079" />
          <Card icon={ShieldCheck} title="Motor Carrier" value="MC 1499189" />
          <Card icon={MapPin} title="Headquarters" value="Houston, TX" />
        </div>

        <div className="mt-12 rounded-xl border border-xd-border bg-xd-paper p-6">
          <h2 className="font-heading text-2xl font-bold">Compliance first</h2>
          <p className="mt-3 text-sm text-xd-muted leading-relaxed">
            XD FREIGHT LLC holds active <span className="text-white font-semibold">property carrier authority</span>.
            Shipper requests are handled as quote requests reviewed directly by the XD team — we do not perform automated
            carrier-to-shipper brokering. Full brokerage features are marked "coming soon, pending authority." XD Score is
            an internal platform-readiness score and is not a credit score, FMCSA safety rating, or any government score.
          </p>
        </div>
      </section>
    </PublicLayout>
  );
}

function Card({ icon: Icon, title, value }) {
  return (
    <div className="bg-xd-paper border border-xd-border rounded-xl p-6">
      <Icon size={24} className="text-xd-orange" />
      <p className="mt-3 text-xs uppercase tracking-wide text-xd-dim">{title}</p>
      <p className="font-heading text-lg font-bold">{value}</p>
    </div>
  );
}
